// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__yH70T","inputs":"Stand_inputs__hBDwp","buttons":"Stand_buttons__4hv3l","checkboxes":"Stand_checkboxes__1Qw6f"};